/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Icon44IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Icon44Icon(props: Icon44IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      fill={"none"}
      xmlns={"http://www.w3.org/2000/svg"}
      className={classNames(
        "plasmic-default__svg",
        className,
        "w-6 h-6 stroke-2 min-w-[1.25rem]"
      )}
      viewBox={"0 0 24 24"}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fillRule={"evenodd"}
        clipRule={"evenodd"}
        d={
          "M18.988 4.687c-.457.11-1.092.363-2.042.743l-9.42 3.768c-1.293.517-2.193.878-2.769 1.197a2.44 2.44 0 00-.45.302c.09.056.246.13.497.214.625.208 1.575.4 2.941.673l.788.158.038.007c.601.12 1.11.222 1.52.351.436.138.825.325 1.155.655.33.33.517.719.654 1.155.13.41.231.918.351 1.52l.008.038.158.788c.273 1.366.465 2.316.673 2.94.084.252.157.407.214.498a2.44 2.44 0 00.302-.45c.318-.576.68-1.476 1.197-2.77l3.768-9.42c.38-.95.632-1.584.743-2.04a1.41 1.41 0 00.055-.382 1.41 1.41 0 00-.381.055zm.43-.046c-.001 0-.005 0-.013-.005.01.002.013.004.012.005zm-.053-.046l-.005-.012s.003.003.005.012zm-.732-1.366c.562-.137 1.277-.205 1.81.329.533.533.465 1.248.329 1.81-.14.574-.434 1.309-.785 2.186l-.023.057-3.768 9.42-.023.057c-.49 1.224-.885 2.213-1.255 2.882-.188.34-.402.659-.665.893-.282.25-.65.425-1.091.385-.441-.04-.772-.28-1.004-.578-.215-.277-.368-.63-.49-.998-.243-.726-.452-1.77-.71-3.063l-.012-.06-.158-.787c-.13-.65-.216-1.078-.318-1.4-.097-.306-.187-.448-.285-.546-.099-.099-.24-.189-.545-.285-.323-.102-.751-.189-1.401-.319l-.788-.157-.059-.012c-1.294-.258-2.338-.467-3.063-.71-.368-.123-.721-.275-.998-.49-.299-.233-.538-.563-.578-1.004-.04-.44.134-.809.385-1.092.234-.262.553-.476.893-.664.669-.37 1.657-.766 2.882-1.256l.056-.022 9.42-3.768.058-.023c.877-.351 1.612-.645 2.186-.785z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  );
}

export default Icon44Icon;
/* prettier-ignore-end */
